import { render } from "./TabOptions.vue?vue&type=template&id=d0cf2462&scoped=true&ts=true"
import script from "./TabOptions.vue?vue&type=script&lang=ts"
export * from "./TabOptions.vue?vue&type=script&lang=ts"

import "./TabOptions.vue?vue&type=style&index=0&id=d0cf2462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0cf2462"]])

export default __exports__